import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

import { TabsComponent } from './tabs/tabs.component';
import { AppVersionComponent } from './app-version/app-version.component';
import { ExcludedCountriesComponent } from './excluded-countries/excluded-countries.component';
import { UserManualComponent } from './user-manual/user-manual.component';

@NgModule({
  imports: [SharedModule],
  declarations: [TabsComponent, AppVersionComponent, ExcludedCountriesComponent, UserManualComponent],
  exports: [TabsComponent, AppVersionComponent, ExcludedCountriesComponent, UserManualComponent]
})
export class LayoutModule {}
